import { QueryClientProvider } from "@tanstack/react-query";
import { AppErrorBoundary } from "@/components/AppErrorBoundary";
import { AppRouterProvider } from "@/app/router/router";
import { createAppQueryClient } from "@/app/providers/query-client";
import { TelemetryRoot } from "@/app/telemetry/posthog";

const queryClient = createAppQueryClient();

export function AppRoot() {
  return (
    <AppErrorBoundary>
      <TelemetryRoot>
        <QueryClientProvider client={queryClient}>
          <AppRouterProvider queryClient={queryClient} />
        </QueryClientProvider>
      </TelemetryRoot>
    </AppErrorBoundary>
  );
}
